<template>
    <b-table
        id="regrasPagamento"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhuma regra de pagamento encontrada.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.codPagamento)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Nome <i class="filter" :class="!isEmpty(filtro.nome) || filtro.filtrarNome == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Nome', 'texto', '', $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            {{ item.nome }}
        </template>
        <template v-slot:head(2)="{ item }">
            Vigência de <i class="filter" :class="!isEmpty(filtro.vigenciaDe) || filtro.filtrarVigenciaDe == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Vigência de', 'data', '', $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            <p class="text-center">
                {{ item.inicioVigencia }}
            </p>
        </template>
        <template v-slot:head(3)="{ item }">
            Vigência até <i class="filter" :class="!isEmpty(filtro.vigenciaAte) || filtro.filtrarVigenciaAte == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Vigência até', 'data', '', $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            <p class="text-center">
                {{ item.fimVigencia }}
            </p>
        </template>
        <template v-slot:head(4)="{ item }">
            Receita <i class="filter" :class="!isEmpty(filtro.receita) || filtro.filtrarReceita == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Receita', 'texto', '', $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            {{ item.receita }}
        </template>
        <template v-slot:head(5)="{ item }">
            Índice <i class="filter" :class="!isEmpty(filtro.indice) || filtro.filtrarIndice == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Índice', 'texto', '', $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            {{ item.indice }}
        </template>
        <template v-slot:head(6)="{ item }">
            Valor Mínimo Parcela (R$) <i class="filter" :class="!isEmpty(filtro.valorMinimo) || filtro.filtrarValorMinimo == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor Mínimo Parcela (R$)', 'numerico', '', $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            <p class="text-right" v-if="item.valorMinimo != null">
                {{ item.valorMinimo | currency }}
            </p>
        </template>
        <template v-slot:head(7)="{ item }">
            Percentual Pré-fixado Honorário (%) <i class="filter" :class="!isEmpty(filtro.percentual) || filtro.filtrarPercentual == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Percentual Pré-fixado Honorário (%)', 'numerico', '', $event)"></i>
        </template>
        <template v-slot:cell(7)="{ item }">
            <p class="text-right" v-if="item.percentual != null">
                {{ item.percentual | currency }}
            </p>
        </template>
        <template v-slot:head(8)="{ item }">
            Usuário Inclusão <i class="filter" :class="!isEmpty(filtro.usuario) || filtro.filtrarUsuario == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário Inclusão', 'texto', '', $event)"></i>
        </template>
        <template v-slot:cell(8)="{ item }">
            {{ item.usuario }}
        </template>
        <template v-slot:head(9)="{ item }">
            Data Inclusão <i class="filter" :class="!isEmpty(filtro.dataInclusao) || filtro.filtrarDataInclusao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Inclusão', 'data', '', $event)"></i>
        </template>
        <template v-slot:cell(9)="{ item }">
            <p class="text-center">
                {{ item.dataInclusao }}
            </p>
        </template>
        <template v-slot:head(10)="{ item }">
            Situação <i class="filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'radio', 'Ativo,Inativo', $event)"></i>
        </template>
        <template v-slot:cell(10)="{ item }">
            {{ item.situacao }}
        </template>
        <template v-slot:head(11)="{ item }">
            Campo Nº Deliberação Conselho e SID <i class="filter" :class="!isEmpty(filtro.deliberacaoConselhoSid) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Campo Nº Deliberação Conselho e SID', 'radio', 'Ativo,Inativo', $event)"></i>
        </template>
        <template v-slot:cell(11)="{ item }">
            {{ item.deliberacaoConselhoSid }}
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';
    
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codPagamento)) {
                        this.selecteds.push(el.codPagamento);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codPagamento)) {
                        const index = this.selecteds.indexOf(el.codPagamento);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.codPagamento);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.codPagamento);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, event) {
            this.$emit('openFilterPopup', campo, tipo, values, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
